// extracted by mini-css-extract-plugin
export default {"wrapper":"DealerLogoUpload_wrapper__I3LOw","hiddenInput":"DealerLogoUpload_hiddenInput__-CxmZ"};